<app-law-firms
	class="mt-2"
	placeholder="Search a lawyer or a law firm"
	[showClerk]="showClerk"
	[lawFirm]="_solicitor"
	(onUpdate)="_onUpdate($event)"
></app-law-firms>
